/* 🤖 this file was generated by svg-to-ts */
export const matIconInsertChartOutlined: {
  name: 'insert-chart-outlined';
  data: string;
} = {
  name: 'insert-chart-outlined',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2 2H5V5h14v14zm0-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/></svg>`
};
